import React from 'react';
import styles from './Performance.module.css';

interface AH01Component extends React.FC {
  title?: string;
}

const AH01: AH01Component = () => {
  return (
    <div>
      <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Metric Description</div>
          <p>
            AOS Order Close Out Rate is used to indicate if acehardware.com orders (BOPIS &amp; BODFS) are closed out by a store within 7 days from the day the order was ready for pickup or delivery.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Supporting Details</div>
          <p>
            Find more information here:{' '}
            <a 
              href="https://acenet.aceservices.com/my-store" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Manage My Store
            </a>
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Goal</div>
          <p>
            100% (all assigned orders closed out in the AOS within 7 days of the Ready for Pickup or Ready for Delivery timestamp).
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Update Cadence</div>
          <p>
            Metric is current state and updated monthly.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Learn More</div>
          <p>
            Ensure your store is closing out orders in a timely manner (within 7 days). 
            <br/>For additional guidance review the Ace Way of Retailing acehardware.com fulfillment{' '}
             <a 
              href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Store Procedures
            </a>
          </p>
      </div>
    </div>
  );
};

AH01.title = 'AOS Order Close Out Rate';
export default AH01;
